import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { menuUrl } from "../customer-list/model/customer-list.constants";
import { createCustomer } from "./customer-create.component.service";
import CustomerCreateTemplateComponent from "./customer-create-template.component";
import { getCustomerInputs } from "../model/customer.modal";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  CUSTOMER_ALERTS: {CREATE_ALERT}
} = MESSAGES;

const CustomerCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct payload
    let customerPayload = {};
    for (let i = 0; i < values.length; i++) {
      customerPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const customerResponse = await createCustomer(customerPayload);

    // INFO : check api response and show relevant alert message
    if (customerResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: customerResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getCustomerInputs({}),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <CustomerCreateTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default CustomerCreateComponent;